import { AlidadeConfigModel } from '../app/core/services/models/alidade-config.model';

export const alidadeConfig: AlidadeConfigModel = {
  baseURL: 'https://dev-alidade.kdg.com.ua',
  apiURL: 'https://dev-alidade.kdg.com.ua/api/v2',
  aiGatewayURL: 'https://dev-alidade.kdg.com.ua/ai-gateway/api',
};
